module.exports = __webpack_public_path__ + "static/img/31.406aec40.png";